import {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import BuyerCard from '../../../components/mazraeKit/cards/buyerCard';
import CustomSearchBox from '../../../components/mazraeKit/customSearchBox';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import SpinnerLoading from '../../../components/SpinnerLoading';
import useGetBuyersListInfinite from '../../../services/hookService/getBuyersListInfinit/useGetBuyersListInfinit';
import UseGetProfileCity from '../../../services/hookService/getProfileCityName/useGetProfileCity';
import {RootState} from '../../../store/redux';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import BuyerListingBottomSheet from './buyersListingBottomSheet';
import FiltersBuyersList from './filtersBuyersList/FiltersBuyersList';
import {googleAnalyticsInstance} from '../../../utilities/helper/googleAnalitics';
import useDebounce from '../../../utilities/hooks/useDebounce/useDebounce';
import NoItemFoundPage from '../../../components/noItemFoundPage';
import {useBuyersListingFilters} from '../../../hooks/filters/useBuyersListingFilter';

const BuyersListing = () => {
  const [inputValue, setInputValue] = useState<string>('');
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const debouncedValue = useDebounce(inputValue, 1000);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const {buyersFilters, setBuyersFilter} = useBuyersListingFilters();
  const navigate = useNavigate();

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const {locational} = useSelector(
    (state: RootState) => state.searchingLocation,
  );

  const cities = locational.map(item => item.id).join(',');

  const payload = {
    search: buyersFilters.search || undefined,
    selected_cities_id: cities || undefined,
    input_groups_guid:
      buyersFilters.input_guid?.map(item => item.guid).join(',') || undefined,
    order_by: buyersFilters.order_by || undefined,
    has_immediate: buyersFilters.has_immediate,
    ...(!cities && {all_ads: true}),
  };

  const {data, isLoading, fetchNextPage, hasNextPage, isFetching} =
    useGetBuyersListInfinite(payload);

  const loaderRef = useInfiniteScroll({
    isLoading,
    fetchNextPage,
    isFetchingNextPage: isFetching,
    hasNextPage,
  });
  const chooseLocationHandler = () => {
    navigate('/choose-location', {
      state: {from: '/buyers-listing'},
    });
    googleAnalyticsInstance.eventGoogleAnalytics({
      category: 'chooseLocation',
      action: 'کاربر روی انتخاب شهرهای دیگر در لیستینگ خریداران کلیک کرد',
    });
  };

  useEffect(() => {
    setBuyersFilter('search', debouncedValue);
  }, [debouncedValue]);
  return (
    <div className="flex overflow-hidden flex-col w-full h-full min-h-0">
      <div className="shrink-0">
        <CustomHeader
          title="خریداران"
          preIcon="icon-nameArrow---Right"
          onClick={() => {
            navigate('/');
          }}
          isActiveRightIcon
        />
      </div>

      <div
        ref={scrollContainerRef}
        id="scrollSection"
        className="overflow-y-auto overscroll-contain flex-1 min-h-0"
      >
        <section className="flex flex-col gap-3 px-3 my-3 w-full">
          <CustomSearchBox
            placeholder="جستجو در فروشگاه "
            type="text"
            value={inputValue}
            inputCustomClass="!pr-8"
            isFloating={false}
            preIcon="icon-nameSearch"
            onChange={onChangeHandler}
            removeIconClassName="!left-24"
            customComponent={() => (
              <div className="flex absolute left-0 top-1/2 items-center px-2 py-2 border-r-2 border-gray-100 -translate-y-1/2">
                <i className="text-xl icon-nameLocation" />

                <span className="text-sm" onClick={chooseLocationHandler}>
                  {' '}
                  {locational?.length
                    ? `${locational?.length} شهرستان`
                    : UseGetProfileCity().profileCity}
                </span>
              </div>
            )}
            {...{inputValue, setInputValue}}
          />

          <div className="flex overflow-x-auto gap-2">
            <button
              className="flex gap-2 items-center px-3 py-2 text-gray-700 rounded-full border w-fit"
              onClick={() => {
                setOpenBottomSheet(true);
              }}
            >
              <i className="font-bold icon-nameFilter text-xxl" />

              <span className="text-sm whitespace-nowrap">فیلتر کردن</span>
            </button>

            <div>
              <FiltersBuyersList />
            </div>
          </div>
        </section>

        <div className="px-3 space-y-4">
          {data?.pages[0].results.length === 0 && !isLoading && (
            <NoItemFoundPage className="h-[60dvh]" />
          )}
          {data?.pages?.flatMap(group =>
            group.results.map(item => (
              <BuyerCard
                key={item.id}
                cardWrapperClassName="!w-full"
                state={item.state?.name || ''}
                city={item.city?.name || ''}
                time={item.created_at}
                message={item.title}
                phone={item.hide_phone_number}
                cardId={item.id}
                supplierGuid={item.supplier_guid}
              />
            )),
          )}

          <div ref={loaderRef} className="w-full h-10" />

          {!isLoading && isFetching && (
            <SpinnerLoading className="flex justify-center items-center py-4 mx-auto mt-4 text-center" />
          )}
        </div>
      </div>

      <BuyerListingBottomSheet {...{openBottomSheet, setOpenBottomSheet}} />

      <div className="shrink-0">
        <MainFooter isScrolling={false} />
      </div>
    </div>
  );
};

export default BuyersListing;
